import ReactGA from "react-ga";

class GoogleAnalyticsManager {
  public static initialize = (id: string) => {
    ReactGA.initialize(id);
  };
}

export default GoogleAnalyticsManager;
